import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';

import GantItemForm from '../gant/form/gantItemForm';
import { GantItemFormProps } from '../gant/form/gantItemFormProps';
import { GantPhaseForm } from '../gant/form/gantPhaseForm';
import { GantProjectForm } from '../gant/form/gantProjectForm';
import { RootState } from '../store';
import { ItemType, MappingItemIdIndexType } from '../types';

export const useGantItemForm = (): [
    React.FC<GantItemFormProps>,
    ItemType | null,
    ItemType[],
    MappingItemIdIndexType,
] => {
    const currentGantItem = useSelector<RootState, ItemType | null>((state) => state.gantItems.currentGantItem);
    const mappingItemIdIndex = useSelector<RootState, MappingItemIdIndexType>((state) => state.gant.mappingItemIdIndex);
    const itemsList = useSelector<RootState, ItemType[]>((state) => state.gantItems.itemsList);

    const ItemForm = useCallback(() => {
        switch (currentGantItem?.roleItem) {
            case 'workItem':
                return GantItemForm;
            case 'project':
                return GantProjectForm;
            case 'phase':
                return GantPhaseForm;
            default:
                return GantItemForm;
        }
    }, [currentGantItem, mappingItemIdIndex, itemsList])();

    return [ItemForm, currentGantItem, itemsList, mappingItemIdIndex];
};
